/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Auto_Release_NoteInputs */

const en_rental_auto_release_note = /** @type {(inputs: Rental_Auto_Release_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If check-in is not confirmed, payout releases automatically 48h after checkout.`)
};

const es_rental_auto_release_note = /** @type {(inputs: Rental_Auto_Release_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si el check-in no se confirma, el pago se libera automáticamente 48h después del checkout.`)
};

const fr_rental_auto_release_note = /** @type {(inputs: Rental_Auto_Release_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si l'arrivée n'est pas confirmée, le paiement est automatiquement débloqué 48h après le départ.`)
};

const de_rental_auto_release_note = /** @type {(inputs: Rental_Auto_Release_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn der Check-in nicht bestätigt wird, wird die Auszahlung automatisch 48 Stunden nach dem Check-out freigegeben.`)
};

const id_rental_auto_release_note = /** @type {(inputs: Rental_Auto_Release_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jika check-in tidak dikonfirmasi, pembayaran otomatis dilepaskan 48 jam setelah checkout.`)
};

/** @type {(inputs: Rental_Auto_Release_NoteInputs) => LocalizedString} */
const ja_rental_auto_release_note = en_rental_auto_release_note;

/** @type {(inputs: Rental_Auto_Release_NoteInputs) => LocalizedString} */
const zh_rental_auto_release_note = en_rental_auto_release_note;

/** @type {(inputs: Rental_Auto_Release_NoteInputs) => LocalizedString} */
const ar_rental_auto_release_note = en_rental_auto_release_note;

/** @type {(inputs: Rental_Auto_Release_NoteInputs) => LocalizedString} */
const it_rental_auto_release_note = en_rental_auto_release_note;

/** @type {(inputs: Rental_Auto_Release_NoteInputs) => LocalizedString} */
const ru_rental_auto_release_note = en_rental_auto_release_note;

/** @type {(inputs: Rental_Auto_Release_NoteInputs) => LocalizedString} */
const pt_rental_auto_release_note = en_rental_auto_release_note;

/** @type {(inputs: Rental_Auto_Release_NoteInputs) => LocalizedString} */
const ko_rental_auto_release_note = en_rental_auto_release_note;

/**
* | output |
* | --- |
* | "If check-in is not confirmed, payout releases automatically 48h after checkout." |
*
* @param {Rental_Auto_Release_NoteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_auto_release_note = /** @type {((inputs?: Rental_Auto_Release_NoteInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Auto_Release_NoteInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_auto_release_note(inputs)
	if (locale === "es") return es_rental_auto_release_note(inputs)
	if (locale === "fr") return fr_rental_auto_release_note(inputs)
	if (locale === "de") return de_rental_auto_release_note(inputs)
	if (locale === "ja") return ja_rental_auto_release_note(inputs)
	if (locale === "zh") return zh_rental_auto_release_note(inputs)
	if (locale === "ar") return ar_rental_auto_release_note(inputs)
	if (locale === "id") return id_rental_auto_release_note(inputs)
	if (locale === "it") return it_rental_auto_release_note(inputs)
	if (locale === "ru") return ru_rental_auto_release_note(inputs)
	if (locale === "pt") return pt_rental_auto_release_note(inputs)
	return ko_rental_auto_release_note(inputs)
});